import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { CandidateTokenStorageService } from '../storage/candidate-token-storage.service';
import { CandidateTenantContextService } from '../tenant/candidate-tenant-context.service';

export const candidateGuestGuard: CanActivateFn = () => {
  const tokens = inject(CandidateTokenStorageService);
  const tenantContext = inject(CandidateTenantContextService);
  const router = inject(Router);

  return tokens.getAccessToken()
    ? router.createUrlTree(['/portal/profile'], { queryParams: tenantContext.getTenantQueryParams() })
    : true;
};
